"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFieldset = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFieldset = styled_components_1.default.fieldset `
  border: 1px solid #d3d3d3;
  border-radius: 5px;

  font-size: 12px;

  padding: 10px;

  legend {
    padding: 10px;
  }
`;
//# sourceMappingURL=elements.js.map